module.exports = __webpack_public_path__ + "static/media/picture_analyze.762dcd91.png";